import React from 'react';
import styled from 'react-emotion';
import Wave from '../components/Wave';
import PropTypes from 'prop-types';

const Wrapper = styled.div`
  z-index: 9;
  width: 100%;
  top: 8.5rem;
  position: absolute;

  @media (max-width: 899px) {
    top: 4.6rem;
  }
  @media (max-width: 599px) {
    height: 4.5rem;
    top: 1.4rem;
  }
  @media (max-width: 450px) {
    height: 4.5rem;
    top: 2.38rem;
  }
  /*  
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    height: 5rem;
    top: 1.75rem;
  }
  @media (max-width: 899px) {
    position: relative;
    height: 4.5rem;
  }
  @media (max-width: 599px) {
    height: 4.5rem;
    top: 5rem;
  }
  @media (max-width: 450px) {
    height: 4.5rem;
    top: 7.2rem;
  }
  */
`;

const WaveNews = ({ orientation }) => (
  <Wrapper>
    <Wave orientation={orientation} />
  </Wrapper>
);

export default WaveNews;

WaveNews.propTypes = {
  orientation: PropTypes.oneOf(['top', 'bottom']),
};

WaveNews.defaultProps = {
  orientation: 'bottom',
};


// WEBPACK FOOTER //
// ./src/components/WaveNews.jsx